// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    RESTOneDrive,
    RESTOneDriveDocument,
} from './';

/**
 * @export
 * @interface RestCopyToDocuments
 */
export interface RestCopyToDocuments {
    /**
     * Specifies IDs of the OneDrive documents that you want to copy. For more information on how to get such IDs, see [Get OneDrive Documents](#tag/OneDriveDocument/operation/OneDriveDocument_Get).
     * @type {Array<RESTOneDriveDocument>}
     * @memberof RestCopyToDocuments
     */
    documents?: Array<RESTOneDriveDocument>;
    /**
     * @type {RESTOneDrive}
     * @memberof RestCopyToDocuments
     */
    onedrive?: RESTOneDrive;
    /**
     * Specifies the target folder for the copied OneDrive documents.
     * @type {string}
     * @memberof RestCopyToDocuments
     */
    folder?: string;
    /**
     * Specifies what version of the OneDrive documents will be copied.
     * @type {string}
     * @memberof RestCopyToDocuments
     */
    documentVersion?: RestCopyToDocumentsDocumentVersionEnum;
    /**
     * Specifies the action that will be performed with the last version of the copied OneDrive document on the destination server.
     * @type {string}
     * @memberof RestCopyToDocuments
     */
    documentLastVersionAction?: RestCopyToDocumentsDocumentLastVersionActionEnum;
    /**
     * Specifies the authentication code. For more information on how to get a device code, see [Get Device Code](#tag/RestoreSession/operation/RestoreSession_DeviceCodeAction). This property is required if you want to use a device code for data restore. 
     * @type {string}
     * @memberof RestCopyToDocuments
     */
    userCode?: string;
    /**
     * Specifies the ID of the Micrisoft Entra application that you want to use for restore.
     * @type {string}
     * @memberof RestCopyToDocuments
     */
    applicationId?: string | null;
    /**
     * Specifies a password.
     * @type {string}
     * @memberof RestCopyToDocuments
     */
    applicationCertificatePassword?: string;
    /**
     * Specifies the SSL certificate configured for the Microsoft Entra application that you want to use for data restore. You must provide the certificate as a Base64 string.
     * @type {string}
     * @memberof RestCopyToDocuments
     */
    applicationCertificate?: string;
    /**
     * Specifies the user name that you want to use for authenticating to the organization.
     * @type {string}
     * @memberof RestCopyToDocuments
     */
    userName?: string;
    /**
     * Specifies a password.
     * @type {string}
     * @memberof RestCopyToDocuments
     */
    userPassword?: string;
    /**
     * Specifies the region of the target Microsoft 365 organization.
     * @type {string}
     * @memberof RestCopyToDocuments
     */
    officeRegion?: RestCopyToDocumentsOfficeRegionEnum;
    /**
     * Specifies the name of the target Microsoft 365 organization.
     * @type {string}
     * @memberof RestCopyToDocuments
     */
    organizationName?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum RestCopyToDocumentsDocumentVersionEnum {
    All = 'All',
    Last = 'Last'
}
/**
 * @export
 * @enum {string}
 */
export enum RestCopyToDocumentsDocumentLastVersionActionEnum {
    Overwrite = 'Overwrite',
    Merge = 'Merge'
}
/**
 * @export
 * @enum {string}
 */
export enum RestCopyToDocumentsOfficeRegionEnum {
    Worldwide = 'Worldwide',
    Germany = 'Germany',
    China = 'China',
    UsDefence = 'USDefence',
    UsGovernment = 'USGovernment'
}

